/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastType } from '@msi/cobalt';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { displayToastNotification } from '../notification/+state/notification.actions';
import { EnvironmentService } from '../core/services/environment.service';
import { UserService } from '../user/services/user.service';

const STATUS_CODE_EXCLUSIONS: (HttpStatusCode | 0)[] = [
    HttpStatusCode.BadGateway,
    HttpStatusCode.GatewayTimeout,
    HttpStatusCode.ServiceUnavailable,
    HttpStatusCode.InternalServerError,
    HttpStatusCode.NotFound,
    HttpStatusCode.Unauthorized,
    HttpStatusCode.RequestTimeout,
    0 // SERVICE WORKER TIMEOUT
];

const URL_EXCLUSIONS: string[] = [
    UserService.USER_LOGOUT_REQUEST
];

export const errorToastInterceptor = (req, next) => {
    const env = inject(EnvironmentService);
    const store = inject(Store);
    return next(req).pipe(catchError((err) => handleError(store, env, err)));
};

const handleError = (store: Store, env: EnvironmentService, error: HttpErrorResponse) => {
    console.error('Error on request', error);
    if (
        !STATUS_CODE_EXCLUSIONS.some((exclusion) => error.status === exclusion) &&
        !URL_EXCLUSIONS.some((urlExclusion) => error.url.includes(urlExclusion)) &&
        !env.environment?.featureFlags?.hideErrorNotifications
    ) {
        store.dispatch(
            displayToastNotification({
                message: getErrorMessage(error),
                level: ToastType.error
            })
        );
    }

    return throwError(() => error);
}

export const getErrorMessage = (error: HttpErrorResponse) => {
    return error.error && error.error.includes && !error.error.includes('</html>')
        ? error.error
        : error.message && !error.message.includes('</html>')
            ? error.message
            : `${error.status} ${error.statusText} ${error.url}`;
}
